import React from 'react';
import { AssetUrls } from 'config/assets';
import './WantListCardOverlay.css';

interface WantListCardOverlayProps {
  cardName: string;
  quantity: number;
  addedCount: number;
  onAddToTrade: () => void;
  onViewCard: () => void;
  onClose?: () => void;
  isMobile?: boolean;
}

export const WantListCardOverlay: React.FC<WantListCardOverlayProps> = ({
  cardName,
  quantity,
  addedCount,
  onAddToTrade,
  onViewCard,
  onClose,
  isMobile = false,
}) => {
  const remainingQuantity = quantity - addedCount;
  const allAdded = remainingQuantity <= 0;

  return (
    <div className="want-list-card-overlay visible">
      {/* Mobile close button */}
      {isMobile && onClose && (
        <button className="want-list-card-overlay-close" onClick={onClose} aria-label="Close">
          ×
        </button>
      )}

      {/* Arrow button to view card details */}
      <button
        className="want-list-card-overlay-arrow"
        onClick={(e) => {
          e.stopPropagation();
          onViewCard();
        }}
        aria-label="View card details"
      >
        <img
          src={`${AssetUrls.base}/assets/icons/Search/icon-arrow-diagonal.svg`}
          alt="View"
          className="want-list-card-overlay-arrow-icon"
        />
      </button>

      {/* Quantity badge if more than 1 remaining */}
      {remainingQuantity > 1 && (
        <div className="want-list-card-overlay-quantity">
          {remainingQuantity} left
        </div>
      )}

      {/* Card title */}
      <span
        className="want-list-card-overlay-title"
        onClick={(e) => {
          e.stopPropagation();
          onViewCard();
        }}
        role="link"
        tabIndex={0}
      >
        {cardName}
      </span>

      {/* Add button or Added state */}
      {allAdded ? (
        <div className="want-list-card-overlay-added">
          <span className="want-list-card-overlay-checkmark">✓</span>
          <span>Added</span>
        </div>
      ) : (
        <button
          className="want-list-card-overlay-button"
          onClick={(e) => {
            e.stopPropagation();
            onAddToTrade();
          }}
        >
          <span>Add to Trade</span>
          <img
            src={AssetUrls.icons.navigation.sending}
            alt=""
            className="want-list-card-overlay-button-icon"
          />
        </button>
      )}
    </div>
  );
};

export default WantListCardOverlay;
